// @flow

export class ActionTypes {
  static Vibrate: string = "vibrate";

  static SyncWithServer: string = "sync-with-server";

  static LogData: string = "log-data";

  static GoToScreen: string = "go-to-screen";

  static Exit: string = "exit";

  static ShowError: string = "show-error";

  static Script: string = "script";

  static None: string = "none";

  static getTitle(actionType: string) {
    switch (actionType) {
      case ActionTypes.Vibrate:
        return "Vibrate";
      case ActionTypes.SyncWithServer:
        return "SyncWithServer";
      case ActionTypes.LogData:
        return "LogData";
      case ActionTypes.GoToScreen:
        return "GoToScreen";
      case ActionTypes.Exit:
        return "Exit";
      case ActionTypes.ShowError:
        return "ShowError";
      case ActionTypes.Script:
        return "Script";
      case ActionTypes.None:
        return "NoAction";
      default:
        return "";
    }
  }
}
